import _ from 'lodash';
import React, { useState } from 'react';
import { graphql } from 'gatsby';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import TeamStats from '../components/team-stats';
import Performance from '../components/Performance';
import Chart from '../components/chart';
import { gamesByOwnerFunc } from '../helpers/game';


const HomePage = (query) => {
  // Get GraphlQL data
  const games = query.data.allGamesJson.nodes;
  const teams = query.data.allOwnersJson.nodes;
	const [team, setTeam] = useState(teams[0]);

  //get games by owner
  const gamesByOwners = gamesByOwnerFunc(games);

  let currentWinStreak = 0;
  let currentWinStreakDate = '';
  let currentLoseStreak = 0;
  let currentLoseStreakDate = '';

  // Rate in percentage of win vs loses per games.
  const rate = (win, loss, tie) => {
		const totalGames = parseInt(win) + parseInt(loss) + parseInt(tie);
		const winPercent = 100 * parseFloat(win + (tie * .5));
		if (win !== 0) {
			return Math.round(winPercent / totalGames);
		}
		else {
			return 0;
		}
	}

  const currentGamesOwner = gamesByOwners.find(x => x.id === team.id);

  //console.log(currentGamesOwner)

  const gamesYearsWeeks = _.groupBy(games, (game) => {
    return [game['year'], game['week']];
  });


  const gamesYears = _.groupBy(games, (game) => {
    return [game['year']];
  });

  //Get season info like number of weeks and when regular season ends
  const seasonsInfo = {};
  const now = new Date();
  const actualYear = now.getFullYear();

  for (let year in gamesYears) {

    const uniqueWeeks = [...new Set(gamesYears[year].map(item => item.week))]; 
    const regularSeasonWeeksPerYear = [...new Set(gamesYears[year].filter(game => {
      return game.playoffTierType === "NONE";
    }).map(item => item.week))]; 

    const regularSeasonEnd = gamesYears[year].find(x => x.playoffTierType === "WINNERS_BRACKET") ? true : false;

    // TODO remove with dynamic option when schedules feature is added.

    let seasonStatusEnd = false;
    if (year < actualYear) {
      seasonStatusEnd = true;
    }

    const winsPerYear = gamesYears[year].reduce((acc, game) => {
      const teamA = game?.team_a[0];
      const teamB = game?.team_b[0];
      if(teamA.ownerId === team.id) {
        if (game?.winner === 'HOME') {
          acc++;
        }
      }
      else if(teamB.ownerId === team.id) {
        if (game?.winner === 'AWAY') {
          acc++;
        }
      }
    
      return acc;

    },0);

    seasonsInfo[year] = {
      firstWeek: uniqueWeeks[0],
      weeks: uniqueWeeks.length,
      regularGames: regularSeasonWeeksPerYear.length,
      wins: winsPerYear,
      regularSeasonEnd,
      seasonStatusEnd
    }
  }

  const lastPlace = new Set();
  const regularSeasonChampion = new Set();
  const playoffAppearances = new Set();
  const championships = new Set();
  const championshipsAppearances = new Set();
  const rankPerYear ={};

  const stats = games.reduce((acc, game) => {
    const teamA = game?.team_a[0];
    const teamB = game?.team_b[0];
    const marginTeamA = teamA.score - teamB.score;
    const marginTeamB = teamB.score - teamA.score;
    const year = game.year;
    const week = game.week;
    const currentDate =  `${year} Week ${week}`;
    const numberOwners = gamesYearsWeeks[year+','+seasonsInfo[year].firstWeek]?.length * 2;
    const regularSeasonWeek = seasonsInfo[year].regularGames;
    const playoffWeek = regularSeasonWeek+1;
    const seasonLength = seasonsInfo[year].weeks;
    const regularSeasonEnd = seasonsInfo[year].regularSeasonEnd;
    const seasonStatusEnd = seasonsInfo[year].seasonStatusEnd;  // TODO remove with dynamic option when schedules feature is added.

    if(teamA.ownerId === team.id) {
      acc.points = parseFloat(acc.points + teamA.score);
      acc.pointsAgaisnt = parseFloat(acc.pointsAgaisnt + teamB.score);

      //Rank stuff
      const rank = parseInt(teamA.rank);

      if (regularSeasonEnd && week === regularSeasonWeek) {
        rankPerYear[year] = rank;
      }
      
      if (rank === numberOwners && regularSeasonEnd && week === regularSeasonWeek ) {
        lastPlace.add(year);
      }
      if (rank === 1 && regularSeasonEnd  && week === regularSeasonWeek) {
        regularSeasonChampion.add(year);
      }

      //Playoffs Appearance 
      if (week === playoffWeek || week > playoffWeek ) {
        playoffAppearances.add(year);
      }

      //Championship Appearance  
      if (week === seasonLength && seasonStatusEnd) {
        championshipsAppearances.add(year);
      }

      // Win lose ties
      if (game?.winner === 'HOME') {
        acc.wins++;
        currentWinStreak++;

        //Championships  
        if (week === seasonLength && seasonStatusEnd ) {
          championships.add(year);
        }

        if (game.playoffTierType !== "NONE") {
          acc.winsPlayoffs++;
        }

        //New streak starting 
        if (currentWinStreak === 1) {
          currentWinStreakDate = currentDate;
        }      
        
        // Lose Streak end
        if (acc.loseStreak < currentLoseStreak) {
          acc.loseStreak = currentLoseStreak;
          acc.loseStart = currentLoseStreakDate;
          acc.loseEnd = currentDate;
        }
        currentLoseStreak = 0;

        //Highest Win Margin 
        acc.highestWinMargin = (acc.highestWinMargin > (marginTeamA)) ? acc.highestWinMargin : (marginTeamA);
        acc.highestWinMarginDate = (acc.highestWinMargin >(marginTeamA)) ? acc.highestWinMarginDate : currentDate + " vs " + teamB.owner;

         //Lowest Win Margin 
         acc.lowestWinMargin = (acc.lowestWinMargin < (marginTeamA) && acc.lowestWinMargin > 0) ? acc.lowestWinMargin : (marginTeamA);
         acc.lowestWinMarginDate = (acc.lowestWinMargin < (marginTeamA)) ? acc.lowestWinMarginDate : currentDate + " vs " + teamB.owner;

      }
      else if (parseFloat(teamB.score) === parseFloat(teamA.score)) {
        acc.ties++;
      }
      else {
        acc.loses++;
        currentLoseStreak++;

        if (game.playoffTierType !== "NONE") {
          acc.losesPlayoffs++;
        }

        //New lose streak starting 
        if (currentLoseStreak === 1) {
          currentLoseStreakDate = currentDate;
        }

        // Win Streak end
        if (acc.winStreak < currentWinStreak) {
          acc.winStreak = currentWinStreak;
          acc.winStart = currentWinStreakDate;
          acc.winEnd = currentDate;
        }

        currentWinStreak = 0;

        //Highest Loss Margin 
        acc.highestLossMargin = (acc.highestLossMargin > (marginTeamB)) ? acc.highestLossMargin : (marginTeamB);
        acc.highestLossMarginDate = (acc.highestLossMargin >(marginTeamB)) ? acc.highestLossMarginDate : currentDate + " vs " + teamB.owner;

        //Lowest Loss Margin 
        acc.lowestLossMargin = (acc.lowestLossMargin < (marginTeamB) && acc.lowestLossMargin > 0) ? acc.lowestLossMargin : (marginTeamB);
        acc.lowestLossMarginDate = (acc.lowestLossMargin < (marginTeamB)) ? acc.lowestLossMarginDate : currentDate + " vs " + teamA.owner;
      }

      //Highest Score 
      acc.highestScore = (acc.highestScore > teamA.score) ? acc.highestScore : teamA.score;
      acc.highestScoreDate = (acc.highestScore > teamA.score) ? acc.highestScoreDate : currentDate + " vs " + teamB.owner;

      //Lowest Score
      acc.lowestScore = (acc.lowestScore < teamA.score && acc.lowestScore > 0) ? acc.lowestScore : teamA.score
      acc.lowestScoreDate = (acc.lowestScore < teamA.score && acc.lowestScore > 0) ? acc.lowestScoreDate : currentDate + " vs " + teamB.owner;

      
    } else if (teamB.ownerId === team.id) {
      acc.points = parseFloat(acc.points + teamB.score);
      acc.pointsAgaisnt = parseFloat(acc.pointsAgaisnt + teamA.score);

      //Rank stuff
      const rank = parseInt(teamB.rank);
      if (regularSeasonEnd && week === regularSeasonWeek) {
      rankPerYear[year] = rank;
      }
      
      if (rank === numberOwners && regularSeasonEnd && week === regularSeasonWeek) {
        lastPlace.add(year);
      }
      if (rank === 1 && regularSeasonEnd && week === regularSeasonWeek) {
        
        regularSeasonChampion.add(year)
      }

      //Playoffs Appearance 
      if (week === playoffWeek || week > playoffWeek) {
        playoffAppearances.add(year);
      }

      //Championship Appearance  

      if (week === seasonLength && seasonStatusEnd) {
        championshipsAppearances.add(year);
      }

      // Win lose ties
      if (game?.winner === 'AWAY') {
        acc.wins++;
        currentWinStreak++;

         //Championships  
        if (week === seasonLength && seasonStatusEnd ) {
          championships.add(year);
        }

        if (game.playoffTierType !== "NONE") {
          acc.winsPlayoffs++;
        }

        //New streak starting
        if (currentWinStreak === 1) {
          currentWinStreakDate = currentDate;
        }   
        
        // Lose Streak end
        if (acc.loseStreak < currentLoseStreak) {
          acc.loseStreak = currentLoseStreak;
          acc.loseStart = currentLoseStreakDate;
          acc.loseEnd = currentDate;
        }
        currentLoseStreak = 0;

        //Highest Win Margin 
        acc.highestWinMargin = (acc.highestWinMargin > (marginTeamB)) ? acc.highestWinMargin : (marginTeamB);
        acc.highestWinMarginDate = (acc.highestWinMargin >(marginTeamB)) ? acc.highestWinMarginDate : currentDate + " vs " + teamA.owner;
        
        //Lowest Win Margin 
        acc.lowestWinMargin = (acc.lowestWinMargin < (marginTeamB) && acc.lowestWinMargin > 0) ? acc.lowestWinMargin : (marginTeamB);
        acc.lowestWinMarginDate = (acc.lowestWinMargin < (marginTeamB)) ? acc.lowestWinMarginDate : currentDate + " vs " + teamA.owner;

      }
      else if (parseFloat(teamB.score) === parseFloat(teamA.score)) {
        acc.ties++;
      }
      else {
        acc.loses++;
        currentLoseStreak++;

        if (game.playoffTierType !== "NONE") {
          acc.losesPlayoffs++;
        }

        //New lose streak starting 
        if (currentLoseStreak === 1) {
          currentLoseStreakDate = currentDate;
        }

        // Win Streak end
        if (acc.winStreak < currentWinStreak) {
          acc.winStreak = currentWinStreak;
          acc.winStart = currentWinStreakDate;
          acc.winEnd = currentDate;
        }
        currentWinStreak = 0;
        
        //Highest Loss Margin 
        acc.highestLossMargin = (acc.highestLossMargin > (marginTeamA)) ? acc.highestLossMargin : (marginTeamA);
        acc.highestLossMarginDate = (acc.highestLossMargin >(marginTeamA)) ? acc.highestLossMarginDate : currentDate + " vs " + teamA.owner;

        //Lowest Loss Margin 
        acc.lowestLossMargin = (acc.lowestLossMargin < (marginTeamA) && acc.lowestLossMargin > 0) ? acc.lowestLossMargin : (marginTeamA);
        acc.lowestLossMarginDate = (acc.lowestLossMargin < (marginTeamA)) ? acc.lowestLossMarginDate : currentDate + " vs " + teamB.owner;
      }

      //Highest Score 
      acc.highestScore = (acc.highestScore > teamB.score) ? acc.highestScore : teamB.score
      acc.highestScoreDate = (acc.highestScore > teamB.score) ? acc.highestScoreDate : currentDate + " vs " + teamA.owner;

      //Lowest Score
      acc.lowestScore = (acc.lowestScore < teamB.score && acc.lowestScore > 0) ? acc.lowestScore : teamB.score
      acc.lowestScoreDate = (acc.lowestScore < teamB.score && acc.lowestScore > 0) ? acc.lowestScoreDate : currentDate + " vs " + teamA.owner;
      
    }

    return acc;

  }, {
    id: team.id,
    points: 0,
    pointsAgaisnt: 0,
    wins:0,
    ties:0,
    loses:0,
    winsPlayoffs:0,
    tiesPlayoffs:0,
    losesPlayoffs:0,
    highestScore:0,
    highestScoreDate: "",
    lowestScore: 0,
    lowestScoreDate: "",
    highestWinMargin: 0,
    lowestWinMargin: 0,
    highestWinMarginDate: "",
    lowestWinMarginDate: "",
    highestLossMargin: 0,
    lowestLossMargin: 0,
    highestLossMarginDate: "",
    lowestLossMarginDate: "",
    winStreak: 0,
    winStart:"",
    winEnd: "",
    loseStreak: 0,
    loseStart:"",
    loseEnd: "",
    bestPlacing : 0,
    bestPlacingYear : '',
    playoffAppearances: 0,
		championshipAppearance: 0,
		championshipWins: 0,
  });
  
  if (!_.isEmpty(rankPerYear)) {
    stats.bestPlacingYear = Object.keys(rankPerYear).reduce((key, v) => rankPerYear[v] < rankPerYear[key] ? v : key);
    stats.bestPlacing = rankPerYear[stats.bestPlacingYear];
  }
  else {
    stats.bestPlacingYear = '';
    stats.bestPlacing = '0';
  }
  stats.regularSeasonChampion = regularSeasonChampion.size;
  stats.regularSeasonChampionYears =  regularSeasonChampion.size > 1 ? new Array(...regularSeasonChampion).join(", ") : regularSeasonChampion; 
  stats.lastPlace = lastPlace.size;
  stats.lastPlaceYears = lastPlace.size > 1 ? new Array(...lastPlace).join(", ") :lastPlace; 
  stats.playoffAppearances = playoffAppearances.size;
  stats.playoffAppearancesYears =  playoffAppearances.size > 1 ? new Array(...playoffAppearances).join(", ") : playoffAppearances; 
  stats.championshipsAppearances = championshipsAppearances.size;
  stats.championshipsAppearancesYears = championshipsAppearances.size > 1 ? new Array(...championshipsAppearances).join(", ") : championshipsAppearances; 
  stats.championships = championships.size;
  stats.championshipsYears =  championships.size > 1 ? new Array(...championships).join(", ") : championships; 

  // Get unique years of all games using a Set Object
  const uniqueYears = [...new Set(currentGamesOwner.games.map(game => game.year))]; 
  stats.founded = currentGamesOwner.games[0].year;
  stats.seasons = uniqueYears.length;
  stats.averageScore = stats.points / currentGamesOwner.games.length;
  stats.averageScoreAgaints = stats.pointsAgaisnt / currentGamesOwner.games.length;

  // set currentStreak
  if (currentWinStreak === 0) {
    stats.currentStreak = currentLoseStreak + "L";
  }
  else {
    stats.currentStreak = currentWinStreak + "W";
  }

  const chartWins = Object.values(seasonsInfo).map(season=> season.wins);
  const dataSet = {
    label: "Wins",
    lineTension: 0.3,
    backgroundColor: "rgb(212, 212, 212,0.3)",// #d4d4d4
    borderColor: "#343a40",
    pointRadius: 5,
    pointBackgroundColor: "#343a40",
    pointBorderColor: "rgba(255,255,255,0.8)",
    pointHoverRadius: 5,
    pointHoverBackgroundColor: "#343a40",
    pointHitRadius: 50,
    pointBorderWidth: 1,
    data: chartWins, 
  }

  const chartData = {
    labels: uniqueYears,
    datasets: [dataSet]
  }

	return (
		<Layout >
			<main className="container-fluid">
				<Breadcrumb title="Franchise Stats" />
				<div className="row">
					<div className="col-xl-5 col-lg-12">
						<TeamStats data={team} stats={stats} teams={teams} 
              change={(e) => {
                setTeam(teams.find(x => x.id === e.target.value));
              }} 
            />
					</div>
          <div className="col-xl-7 col-lg-12">
							<Performance
								title="Regular Season"
								rate={rate((stats.wins - stats.winsPlayoffs), (stats.loses - stats.losesPlayoffs), (stats.ties - stats.tiesPlayoffs))}
								win={stats.wins - stats.winsPlayoffs}
								loss={stats.loses - stats.losesPlayoffs}
								tie={stats.ties - stats.tiesPlayoffs}
								boxa={{ title: 'Regular Season Champion', content:stats.regularSeasonChampion, subcontent:stats.regularSeasonChampionYears}}
								boxb={{ title: 'Best Placing', content:stats.bestPlacing, subcontent:stats.bestPlacingYear}}
								boxc={{ title: 'Last Place', content:stats.lastPlace, subcontent:stats.lastPlaceYears }}
							/>
							<Performance
								title="Playoff"
								rate={rate(stats.winsPlayoffs,stats.losesPlayoffs,stats.tiesPlayoffs)}
								win={stats.winsPlayoffs}
								loss={stats.losesPlayoffs}
								tie={stats.tiesPlayoffs}
								boxa={{ title: 'Playoffs Appearances', content:stats.playoffAppearances, subcontent: stats.playoffAppearancesYears }}
								boxb={{ title: 'Championships Appearance', content:stats.championshipsAppearances, subcontent: stats.championshipsAppearancesYears }}
								boxc={{ title: 'Championships', content:stats.championships, subcontent: stats.championshipsYears }}
							/>
						</div>
          
				</div>
        <Chart data={chartData} />
			</main>
		</Layout>
		);
};

export default HomePage;

export const pageQuery = graphql`
{
  allGamesJson {
    nodes {
      id
      year
      winner
      week
      playoffTierType
      team_a {
        logo
        name
        owner
        ownerId
        rank
        score
      }
      team_b {
        logo
        name
        owner
        ownerId
        rank
        score
      } 
    }
  }
  allOwnersJson {
    nodes {
      fantasyname
      id
      image
      name
      status
    }
  }
}
`;
